import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { getAppProps } from '@pages/_app';

import TemplateDefault from '../../templates/default/default';
import Iframe from '../../atoms/Iframe/Iframe';
import Container from '../../layout/container/container';
import { getSpace } from '../../../stylesheets/tools';

const StyledContainer = styled(Container)`
  margin-top: ${getSpace('xxxl')};
`;

const BookingConfirmation = ({ goUrl }) => (
  <TemplateDefault fallbackTitle="Booking Confirmation">
    <StyledContainer>
      {goUrl && <Iframe file={goUrl} title="Booking Confirmation" />}
    </StyledContainer>
  </TemplateDefault>
);

BookingConfirmation.propTypes = {
  goUrl: PropTypes.string
};

const getBookingConfirmationProps = async ({ locale, goUrl }) => {
  return {
    PAGE_TYPE: 'BOOKINGCONFIRMATION',
    ...(await getAppProps({ locale })),
    goUrl: goUrl || null
  };
};

export default BookingConfirmation;
export { getBookingConfirmationProps };
